/* eslint-disable no-useless-concat */
import React from "react";
import { Container, Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './DRDetail.css';
import { CaretUpIcon, CaretDownIcon, PDFIcon } from '../../components/Icons';
import NewsSection from "../../sections/News/News";
import DRChart from './DRChart';
import DRChartCompare from "./DRChartCompare";
import RecommendDR from "../../sections/RecommendDR/RecommendDR";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function withParams(Component) {
    return (props) => <Component {...props} params={useParams()} />;
}

class DRDetail extends React.Component {

    constructor(props) {
        super(props);
        var { stockSymbol } = props.params;
        this.state = {
            stocks: [],
            aboutDr: [],
            isAboutDrLoading: true,
            documentPaper: [],
            isDocumentPaperLoading: true,
            activeTab: 0,
            stockSymbol,
            showCompareChart: false,
        };
    }
    async loadContent(url) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        }
        catch {
            console.log("Error");
            return [];
        }
    }
    async loadDRInfo() {
        var url = 'api/MarketData/GetDRStatus?symbol=' + this.props.params.stockSymbol;
        var result = await this.loadContent(url);
        if (result !== null && result.length <= 0) {
            console.error(result);
        } else {
            this.setState({ stocks: result });
        }
    }
    async loadAboutDr() {
        var url = 'api/Content/GetAboutDR?symbol=' + this.props.params.stockSymbol;
        var result = await this.loadContent(url);
        if (result !== null && result.data !== null && result.data.length <= 0) {
            console.warn(result);
        }
        this.setState({ isAboutDrLoading: false, aboutDr: result.data !== null ? result.data : [] });
    }
    async loadDocumentPaper() {
        var url = 'api/Content/GetDocumentPaper?symbol=' + this.props.params.stockSymbol;
        var result = await this.loadContent(url);
        if (result !== null && result.data !== null && result.data.length <= 0) {
            console.warn(result);
        }
        this.setState({ isDocumentPaperLoading: false, documentPaper: result.data !== null ? result.data : [] });
    }
    async componentDidMount() {
        this.loadDRInfo();
        this.loadAboutDr();
        this.loadDocumentPaper();
    }

    async componentDidUpdate(prevProps) {
        if (this.props.params !== prevProps.params) {
            this.loadDRInfo();
            this.loadAboutDr();
            this.loadDocumentPaper()
        }
    }

    kbToMb(kb) {
        return (kb / 1024).toFixed(2);
    }

    floatFormat(number) {
        return parseFloat(number).toFixed(2);
    }

    render() {

        var { stocks, activeTab, aboutDr, documentPaper, showCompareChart } = this.state;
        var { stockSymbol } = this.props.params;
        var lastPrice = 0.00;
        var peRatio = 0;

        if (stocks.length > activeTab) {
            lastPrice = stocks[activeTab].lastPrice;

            peRatio = stocks[activeTab].peRatio <= 0 && activeTab === 0 ? this.floatFormat(stocks[activeTab + 1].peRatio) : this.floatFormat(stocks[activeTab].peRatio);
            peRatio = peRatio === '0.00' ? '-' : peRatio;
        }
                

        return <>
            <Helmet>
                <title>{`DR19 - ${stockSymbol}`}</title>
            </Helmet>
            <Container id="dr-detail">
                <Row>
                    <Col>
                        <div id="dr-detail-tabs">
                            {stocks.map((stock, i) =>
                                <button
                                    key={`stock-tab-${i}`}
                                    className={`${i === activeTab && showCompareChart === false ? "active" : ""} ${stock.percentChange < 0 ? "red" : "green"}`}
                                    onClick={() => this.onChangeTab(i)}
                                >
                                    {stock.change >= 0 ? <CaretUpIcon /> : <CaretDownIcon />}
                                    {stock.displayName}
                                </button>)}
                            <button

                                className={`${showCompareChart === true ? "active" : ""}`}
                                onClick={() => this.setState({ showCompareChart: true, activeTab: 0 })}
                            >
                                Compare
                            </button>
                        </div>
                        <UncontrolledDropdown id="dr-detail-dropdown" onChange={(value) => console.log(value)}>
                            {stocks && stocks.length > activeTab && <DropdownToggle caret className={`${stocks[activeTab].percentChange < 0 ? "red" : "green"}`}>
                                {showCompareChart === false && <>{stocks[activeTab].change >= 0 ? <CaretUpIcon /> : <CaretDownIcon />} {stocks[activeTab].displayName}</>}
                                {showCompareChart === true && <>Compare</>}
                            </DropdownToggle>}
                            <DropdownMenu>
                                {stocks.map((stock, i) =>
                                    <DropdownItem key={`dropdown-item-${i}`} className={`${stock.percentChange < 0 ? "red" : "green"}`} onClick={() => this.onChangeTab(i)}>
                                        {stock.change >= 0 ? <CaretUpIcon /> : <CaretDownIcon />}
                                        {stock.displayName}
                                    </DropdownItem>)}
                                <DropdownItem onClick={() => this.setState({ showCompareChart: true, activeTab: 0 })}>Compare</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        <div className="text-color-2">
                            <p>{(stocks.length > activeTab) ? stocks[activeTab].shortDescription : ""}</p>
                        </div>

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div style={{ height: '420px' }}>
                            {(showCompareChart === false && activeTab >= 0) && <DRChart symbol={(stocks.length > activeTab) ? stocks[activeTab].symbol : ""} lastPrice={lastPrice} />}
                            {(showCompareChart === true && stocks && stocks.length === 2) && <DRChartCompare stocks={stocks} />}
                        </div>
                        <br />
                        <NewsSection className='no-border' targetSymbol={(stockSymbol !== null && stockSymbol !== "") ? stockSymbol : "EVERY_SYMBOL"} />
                    </Col>
                    <Col md={4}>
                        <div className="round-box-2">
                            <div className="status-word-container">
                                <div className="round-box-status-title">
                                    DR Status
                                </div>
                                <div className="currency-wording">
                                    ( {stocks.length > activeTab && activeTab <= 2 ? stocks[activeTab].currency : ""} )
                                </div>
                            </div>
                            <div className="round-box-2-body">
                                {stocks.length > activeTab && <table className="pretty-table">
                                    <tbody>
                                        <tr>
                                            <td>PREVIOUS CLOSE</td>
                                            <td className="bold">{(stocks[activeTab].close > 0.0 ? this.floatFormat(stocks[activeTab].close) : '-')}</td>
                                        </tr>
                                        <tr>
                                            <td>{(activeTab === 0 ? 'Fair BID - Fair ASK' : 'BID - ASK')}</td>
                                            <td className="bold">{(stocks[activeTab].bid !== 0 && stocks[activeTab].ask !== 0) ? this.floatFormat(stocks[activeTab].bid) + ' - ' + this.floatFormat(stocks[activeTab].ask) : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>P/E RATIO</td>
                                            <td className="bold">{peRatio}</td>
                                        </tr>
                                        <tr>
                                            <td>DIVIDEND YIELD</td>
                                            <td className="bold">{stocks[activeTab].dividendYield <= 0 ? '-' : this.floatFormat(stocks[activeTab].dividendYield) + ' %'}</td>
                                        </tr>
                                    </tbody>
                                </table>}
                            </div>
                        </div>
                        <br />
                        <div className="round-box-2">
                            <div className="round-box-2-title" key={`about-top-header`}>
                                About
                            </div>
                            <div className="round-box-2-body">
                                {this.state.isAboutDrLoading
                                    ? <p key={`loading-tag`}><em>Loading...</em></p>
                                    :
                                    aboutDr.map((about, idx) =>
                                        <div key={`about-head-${idx}`}><p>
                                            <strong className="h-highlight" key={`about-strong-${idx}`}>
                                                {about.properties.headerText}
                                            </strong>
                                        </p>
                                            <p key={`about-content-${idx}`}>
                                                {about.properties.contentText}
                                            </p>
                                            <br></br>
                                        </div>)
                                }
                            </div>
                        </div>
                        <br />
                        <div className="round-box-2">
                            <div className="round-box-2-title">
                                เอกสารชี้ชวน
                            </div>
                            <div className="round-box-2-body">
                                <table className="pretty-table">
                                    <tbody>
                                        {this.state.isDocumentPaperLoading
                                            ? <tr><td><p key={`loading-tag-document`}><em>Loading...</em></p></td></tr>
                                            :
                                            documentPaper.map((documentPaper, idx) =>
                                                <tr key={`file-row-${idx}`}>
                                                    <td><a href={documentPaper.properties.url} target='_blank' rel='noreferrer' key={`href-documentpaper-${idx}`}><PDFIcon /> {documentPaper.properties.name}</a></td>
                                                    <td className="light" key={`filesize-documentpaper-${idx}`}>{this.kbToMb(documentPaper.properties.size)} MB</td>
                                                </tr>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col><br /><br /></Col>
                </Row>
            </Container>
            <div style={{ background: '#FAFAFA' }}>
                <Container>
                    <Row>
                        <Col>
                            <RecommendDR mode='related' symbol={stockSymbol} />
                            <br />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    }

    onChangeTab(index) {
        this.setState({ activeTab: index, showCompareChart: false });
    }
}

export default withParams(DRDetail);